"use client";

import { X } from "lucide-react";
import { formatFilterClauseLabel } from "../app";
import { TableFilters } from "./table-filters";


import { MAX_CLIENT_ROWS } from "./smart-table-shared";

import { useSmartTableModelContext } from "./smart-table-model-context";

export function ActiveFilters<TData>() {
  const m = useSmartTableModelContext<TData>();
  const { columns, data, filters, clientFilters, lists, showFilters, setShowFilters, filterPopoverColumn, setHoveredFilter, t, displayData, isRowLimited, removeFilter, locale, recent, onFiltersChangeWithHistory, bulkSaveError } = m;
  return (
    <>
      {showFilters && (
        <TableFilters
          columns={columns}
          lists={lists}
          filters={filters}
          onFiltersChange={onFiltersChangeWithHistory}
          previewCount={displayData.length}
          totalCount={data.length}
          popoverColumn={filterPopoverColumn}
          onChipHover={setHoveredFilter}
          onClose={() => setShowFilters(false)}
          recentFilters={recent}
          onApplyRecent={(f) => onFiltersChangeWithHistory(f)}
        />
      )}

      {filters.length > 0 && !showFilters && (
        <div className="flex flex-wrap gap-2">
          {filters.map((f, idx) => (
            <span
              key={idx}
              className="filterChip inline-flex items-center gap-1 rounded-full bg-surface px-3 py-1 text-xs cursor-pointer hover:bg-surface/80"
              onClick={() => {
                setShowFilters(true);
              }}
            >
              {formatFilterClauseLabel(f, lists, locale, {
                chipIsEmpty: t("chipIsEmpty"),
                chipIsNotEmpty: t("chipIsNotEmpty"),
              })}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  removeFilter(idx);
                }}
                className="ml-1 text-text-secondary hover:text-text-primary"
                aria-label={t("table.removeFilter")}
              >
                <X className="h-3 w-3" />
              </button>
            </span>
          ))}
        </div>
      )}

      {clientFilters.length > 0 && (
        <div className="rounded-md border border-warning/40 bg-warning-soft px-4 py-2 text-sm text-warning-dark">
          {clientFilters.length} {t("table.clientFilters")}:{" "}
          {clientFilters.map((f) => f.column).join(", ")}
        </div>
      )}

      {isRowLimited && (
        <div className="rounded-md border border-warning/40 bg-warning-soft px-4 py-2 text-sm text-warning-dark">
          {t("table.rowLimit.warning", {
            count: MAX_CLIENT_ROWS,
            total: data.length,
          })}
        </div>
      )}

      {bulkSaveError !== null && (
        <div className="rounded-md border border-danger/40 bg-danger-soft px-4 py-2 text-sm text-danger-dark">
          {bulkSaveError}
        </div>
      )}

    </>  );
}
